module.exports = __webpack_public_path__ + "img/Studi_Kasus_Contoh.a0720006.jpeg";